export var gradientBackground = '$_4Mid3';
export var shadow = '$_2flQ8';
export var transitionPropertyTransformMaxHeight = '_3Cz71';
export var transitionPropertyTransformOpacity = '_3TFU4';
export var transformUp = '$_3hxs5';